const TRANSFORMER_MAX_MOBILE_WIDTH_PX = 767;
const TRANSFORMER_MIN_DESKTOP_WIDTH_PX = 768;
const OVERLAY_VIEWPORT_Z_INDEX_CLASS = 'z-[500]';
const DRAWER_SWIPE_IGNORE_ATTRIBUTE = 'data-base-ui-swipe-ignore';
const DEFAULT_IMAGE_URL = 'https://s1.pclncdn.com/design-assets/brand-assets/default_image.jpeg';
export { DEFAULT_IMAGE_URL, DRAWER_SWIPE_IGNORE_ATTRIBUTE, OVERLAY_VIEWPORT_Z_INDEX_CLASS, TRANSFORMER_MAX_MOBILE_WIDTH_PX, TRANSFORMER_MIN_DESKTOP_WIDTH_PX };
